// Single source of truth for canonical URLs, per-route metadata, and structured data.
// Change SITE_URL here when the production domain changes — sitemap and prerender read it too.
export const SITE_URL = 'https://iplsistem.id';
export const SITE_NAME = 'Sistem IPL';
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

export const routes = {
  home: {
    path: '/',
    title: 'Sistem IPL - Kelola IPL Perumahan Lebih Mudah',
    description:
      'Platform digital untuk mengelola Iuran Pemeliharaan Lingkungan kompleks Anda. Otomatisasi tagihan, notifikasi WhatsApp, laporan keuangan, dan PPOB dalam satu sistem.',
  },
  download: {
    path: '/download',
    title: 'Download Aplikasi Sistem IPL (APK Android)',
    description:
      'Unduh aplikasi Sistem IPL untuk Android. Panduan pemasangan APK langkah demi langkah, lengkap dengan QR code untuk unduh langsung dari ponsel.',
  },
  privacy: {
    path: '/kebijakan-privasi',
    title: 'Kebijakan Privasi Aplikasi IPL - PT Nuratech Digital Nusantara',
    description:
      'Kebijakan privasi resmi aplikasi IPL (Android & Web) PT Nuratech Digital Nusantara. Penjelasan pengumpulan data, izin perangkat, keamanan, dan hak penghapusan akun sesuai UU PDP No. 27/2022.',
  },
  terms: {
    path: '/syarat-ketentuan',
    title: 'Syarat & Ketentuan - Sistem IPL',
    description:
      'Ketentuan penggunaan layanan Sistem IPL: ruang lingkup layanan, langganan dan pembayaran, kewajiban pengguna, serta batasan tanggung jawab.',
  },
  knowledgeCenter: {
    path: '/knowledge-center',
    title: 'Knowledge Center & Video Tutorial - Sistem IPL',
    description:
      'Kumpulan video tutorial dan panduan lengkap penggunaan aplikasi Sistem IPL, mulai dari instalasi APK Android hingga pengelolaan iuran perumahan.',
  },
  checkout: {
    path: '/checkout',
    title: 'Berlangganan Sistem IPL',
    description: 'Lengkapi data kompleks Anda untuk memulai langganan Sistem IPL.',
    noindex: true, // transient funnel step, nothing to rank
  },
  payment: {
    path: '/payment',
    title: 'Instruksi Pembayaran - Sistem IPL',
    description: 'Instruksi pembayaran langganan Sistem IPL.',
    noindex: true, // unreachable without checkout state
  },
};

// Routes that get their own static HTML file at build time.
export const prerenderRoutes = [
  routes.home.path,
  routes.download.path,
  routes.knowledgeCenter.path,
  routes.privacy.path,
  routes.terms.path,
];

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo-ipl-removebg.webp`,
  description:
    'Platform digital untuk mengelola Iuran Pemeliharaan Lingkungan (IPL) kompleks perumahan.',
  email: 'info@iplsistem.id',
  telephone: '+62-878-8681-5136',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Jakarta',
    addressCountry: 'ID',
  },
  sameAs: ['https://nuratech.id'],
};

export const softwareSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: SITE_NAME,
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Android, Web',
  url: SITE_URL,
  description:
    'Perangkat lunak pengelolaan Iuran Pemeliharaan Lingkungan untuk pengurus kompleks perumahan.',
  offers: {
    '@type': 'Offer',
    priceCurrency: 'IDR',
    price: '0',
    description: 'Hubungi kami untuk penawaran harga sesuai jumlah unit kompleks Anda.',
  },
  publisher: { '@type': 'Organization', name: SITE_NAME, url: SITE_URL },
};

export const knowledgeCenterSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: 'Panduan Pemasangan Aplikasi Sistem IPL (Izin Sumber Tidak Dikenal / Unknown Apps)',
    duration: 'PT2M',
    description:
      'Panduan lengkap langkah demi langkah mengenai cara mengunduh berkas APK resmi, memberikan izin pemasangan aplikasi dari sumber tidak dikenal (Install Unknown Apps), hingga berhasil memasang dan membuka aplikasi Sistem IPL.',
    thumbnailUrl: `${SITE_URL}/logo-ipl-removebg.webp`,
    uploadDate: '2026-09-24T08:00:00+07:00',
    contentUrl: 'https://storage.iplsistem.id/tutorial/Tutorial%20Instalasi%20Aplikasi%20IPL.mp4',
    embedUrl: `${SITE_URL}/knowledge-center`,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: 'Panduan Pembayaran Tagihan IPL (Aplikasi Sistem IPL)',
    duration: 'PT2M',
    description:
      'Panduan lengkap langkah demi langkah mengenai cara melakukan pembayaran tagihan iuran pemeliharaan lingkungan (IPL) secara praktis, cepat, dan aman melalui aplikasi Sistem IPL.',
    thumbnailUrl: `${SITE_URL}/logo-ipl-removebg.webp`,
    uploadDate: '2026-09-24T08:00:00+07:00',
    contentUrl: 'https://storage.iplsistem.id/tutorial/Tutorial%20Pembayaran%20Aplikasi%20IPL.mp4',
    embedUrl: `${SITE_URL}/knowledge-center`,
  },
];

